import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import Link from '../../../Link';
import { clickSignupButton } from '../../events';

import styles from './styles.sass';
import LinkStyles from '../../LinkStyles.sass';

const cx = classnames.bind(styles);
const cxLinkStyles = classnames.bind(LinkStyles);

const SignUpLoginNavItems = ({ pathname }) => (
  <div className={styles.wrapper}>
    <Link
      to="/signup"
      className={styles.buttonLink}
      onClick={clickSignupButton}
    >
      Sign up
    </Link>
    <Link
      to="/login"
      className={`${styles.link} ${cxLinkStyles({
        link: true,
        linkActive: pathname === '/login',
      })}`}
    >
      Log in
    </Link>
  </div>
);

SignUpLoginNavItems.defaultProps = {
  pathname: null,
};

SignUpLoginNavItems.propTypes = {
  pathname: PropTypes.string,
};

export { SignUpLoginNavItems };
